import React from "react";
import "./LeftColumn.css";
import headShot from "../images/headshot_px.png";
import { Button } from "antd";

function LeftColumn() {
  return (
    <div className="left-column">
      <img className="headshot" src={headShot} />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
        malesuada lacus sit amet lorem lacinia, a finibus erat lobortis. Fusce
        mollis metus nunc, iaculis malesuada urna blandit rhoncus. Nulla luctus
        eu ex et faucibus.
      </p>
      <div className="normal_button">
        <a href="https://enrique.zone">enrique.zone</a>
      </div>
    </div>
  );
}

export default LeftColumn;
